import React, { useEffect, useState } from "react";
import { get_feature_status } from "../../Controllers/FeatureLock";
import toast from "react-hot-toast";

const FeatureLockWrapper = ({
  children,
  featureKey,
  lockedComponent = null,
  showLockIcon = true,
  onClick = null,
  className = "",
  style = {}
}) => {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [featureDetails, setFeatureDetails] = useState(null);

  useEffect(() => {
    checkFeatureStatus();
  }, [featureKey]);

  const checkFeatureStatus = async () => {
    try {
      setIsLoading(true);
      const response = await get_feature_status({ feature_key: featureKey });

      if (response?.status) {
        setIsUnlocked(response.data?.is_unlocked || false);
        setFeatureDetails(response.data?.feature || null);
      } else {
        setIsUnlocked(false);
      }
    } catch (error) {
      console.error("Error checking feature status:", error);
      setIsUnlocked(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = (e) => {
    if (!isUnlocked && onClick) {
      onClick(e, featureDetails);
      return;
    }

    if (!isUnlocked && !onClick) {
      e.preventDefault();
      e.stopPropagation();
      toast.error(`This feature is locked. Please upgrade to unlock "${featureDetails?.name || 'this feature'}".`);
    }
  };

  /*   if (isLoading) {
      return <div className="opacity-50 pointer-events-none">{children}</div>;
    }
  
    if (isUnlocked) {
      return React.cloneElement(children, {
        className: `${children.props.className || ''} ${className}`,
        style: { ...children.props.style, ...style }
      });
    } */

  if (lockedComponent) {
    return React.cloneElement(lockedComponent, {
      onClick: (e) => handleClick(e),
      className: `${lockedComponent.props.className || ''} ${className} feature-locked`,
      style: { ...lockedComponent.props.style, ...style }
    });
  }

  /*   return React.cloneElement(children, {
      onClick: (e) => handleClick(e),
      className: `${children.props.className || ''} ${className} relative`,
      style: { ...children.props.style, ...style },
      children: (
        <>
          {children.props.children}
          {showLockIcon && (
            <div className="absolute inset-0 flex items-center justify-center rounded-lg">
              <div className="absolute bottom-1 right-1 w-4 h-4">
                <svg
                  className="w-full h-full text-red-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          )}
        </>
      )
    }); */

  if (isLoading) {
    return null;
  }

  if (!isUnlocked) {
    return null;
  }

  return React.cloneElement(children, {
    className: `${children.props.className || ''} ${className}`,
    style: { ...children.props.style, ...style }
  });
  
};

FeatureLockWrapper.isFeatureUnlocked = async (featureKey) => {
  try {
    const response = await get_feature_status({ feature_key: featureKey });
    return response?.status ? response.data?.is_unlocked || false : false;
  } catch (error) {
    console.error("Error checking feature status:", error);
    return false;
  }
};

export default FeatureLockWrapper;